<div class="app-loading" [class.app-loading--compact]="hideText">
  <mat-spinner class="dbc1-spinner dbc1-spinner--md" diameter="28"></mat-spinner>
  <p class="app-loading__text" *ngIf="!hideText">{{ text || ("loading" | translate) }}</p>
</div>
